<script lang="ts">
    import Tooltip from "../../../../../../ui/Tooltip/Tooltip.svelte";

  export let type: 'input' | 'textarea' = 'input'
  export let placeholder: string
  export let required: boolean
  export let isError: boolean
  export let title: string
  export let value: string
  export let tooltip = ''
  export let isOnlyNumbers = false

  $: value = isOnlyNumbers ? value.toString().replace(/[^0-9]/g, '') : value
</script>

<div class="form-group">
  <div class="title">
    <div>{title}</div>

    {#if tooltip}
      <Tooltip {tooltip}>
        <i class="icon-question" />
      </Tooltip>
    {/if}

    {#if required}
      <div class="required-title">*обязательное поле</div>
    {/if}
  </div>

  {#if type === 'input'}
    <input 
      {placeholder}  
      bind:value
      type="text" 
      style:border-color={isError ? '#FB7662' : '#B6C8F9'} 
    />
  {/if}

  {#if type === 'textarea'}
    <textarea 
      {placeholder} 
      bind:value
      rows="3" 
    />
  {/if}
</div>

<style lang="scss">
  .form-group {
    margin-bottom: 16px;
  }

  .icon-question {
    color: #5A5F6D99;
    font-size: 14px;
    margin-left: 7px;
  }

  .title {
    color: #30333D;
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  
    .required-title {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0em;
      color: #5A5F6D99;
      margin-left: 8px;
    }
  }

  textarea {
    resize: none;
  }

  input, textarea {
    border: 1px solid #B6C8F9;
    padding: 12px;
    background-color: white;
    outline: none;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0em;
    color: #30333D;

    &::placeholder {
      color: #5A5F6D99;
      font-size: 16px;
      line-height: 23px;
      letter-spacing: 0em;
    }
  }
</style>